import React, { createContext, useState, useContext, useRef } from "react";
import { GetWSMgr } from "@/Utils/StateLib";
import { useAppNavigate } from "@/hooks/useAppNavigate";
const ChartSettingsContext = createContext();

const ChartSettingsProvider = ({ children }) => {
  const [chartConfig, setChartConfig] = useState(null);
  const chartConfigRef = useRef(null);
  const [showCreateChartModal, setShowCreateChartModal] = useState(false);
  const [clonedChartConfig, setClonedChartConfig] = useState(null);
  const [showForceRefreshModal, setShowForceRefreshModal] = useState(false);
  const [showReloadFormulasModal, setShowReloadFormulasModal] = useState(false);
  const nav = useAppNavigate();

  const launchChartSettings = (chartID = 0) => {
    nav.toChartSettings(String(chartID));
  };

  const ReportEventLaunchChartSettings = () => {
    const wsMgr = GetWSMgr();
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("chart_settings.settings.opened");
  };

  const updateChartConfigRef = nextConfigData => {
    setChartConfig(nextConfigData);
    chartConfigRef.current = nextConfigData;
  };

  return (
    <ChartSettingsContext.Provider
      value={{
        chartConfig,
        chartConfigRef,
        clonedChartConfig,
        setClonedChartConfig,
        showCreateChartModal,
        setShowCreateChartModal,
        setChartConfig,
        launchChartSettings,
        updateChartConfigRef,
        ReportEventLaunchChartSettings,
        showForceRefreshModal,
        setShowForceRefreshModal,
        showReloadFormulasModal,
        setShowReloadFormulasModal
      }}
    >
      {children}
    </ChartSettingsContext.Provider>
  );
};

export const useChartSettingsContext = () => useContext(ChartSettingsContext);

export default ChartSettingsProvider;
